import { Link } from 'react-router-dom';
import './LandingPage.css';

export default function LandingPage() {
  return (
    <div className="landing-container">
      <nav className="landing-nav" role="navigation" aria-label="Main navigation">
        <div className="nav-content">
          <h2 className="nav-logo">🎓 BriteTalker</h2>
          <Link to="/login" className="nav-login-btn">
            Sign In
          </Link>
        </div>
      </nav>

      <main className="landing-main">
        <div className="hero-section">
          <div className="hero-content">
            <h1 className="hero-title">
              Learn English with <span className="hero-brand">BriteTalker</span>
            </h1>
            <p className="hero-description">
              Find your perfect English teacher. Book 1-on-1 lessons with qualified teachers at fair
              prices — no hidden fees, no platform lock-in.
            </p>
            <div className="hero-actions">
              <Link to="/login" className="cta-button primary">
                Find a Teacher
              </Link>
              <button
                className="cta-button secondary"
                onClick={() => {
                  document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Learn More
              </button>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-card">
              <div className="card-header">
                <div className="card-dots">
                  <span className="dot dot-red"></span>
                  <span className="dot dot-yellow"></span>
                  <span className="dot dot-green"></span>
                </div>
                <div className="card-title">BriteTalker</div>
              </div>
              <div className="card-content">
                <div className="feature-item">
                  <div className="feature-icon">👩‍🏫</div>
                  <div className="feature-text">Qualified Teachers</div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">💰</div>
                  <div className="feature-text">Fair Pricing</div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">📅</div>
                  <div className="feature-text">Flexible Scheduling</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section id="features" className="features-section">
          <div className="features-content">
            <h2 className="features-title">Why Choose BriteTalker?</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon-large">🎯</div>
                <h3>1-on-1 Lessons</h3>
                <p>
                  Personalised attention from experienced English teachers. 25 or 50 minute sessions
                  that fit your schedule.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon-large">💸</div>
                <h3>Lower Fees</h3>
                <p>
                  Teachers keep more of what they earn. No sliding fee scales, no hidden charges —
                  just a simple, fair platform fee.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon-large">📚</div>
                <h3>Structured Courses</h3>
                <p>
                  Teachers offer structured curriculum with lesson plans, quizzes, and homework —
                  not just conversation practice.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <p>&copy; 2026 BriteTalker. Learn English, your way.</p>
      </footer>
    </div>
  );
}
